import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  availableLangs: string[];
  constructor(private translate: TranslateService) {
    this.availableLangs = ['en', 'fr'];
  }
  currentAppLanguage(): any {
    return this.translate.currentLang;
  }

  setAppLangOnStartup(): any {
    let browserLang = this.translate.getBrowserLang();
    const prevLang = localStorage.getItem('lang');
    if (prevLang != undefined) {
      this.changeLanguage(prevLang, false);
    } else if (browserLang != undefined) {
      const isLangAvailable = this.availableLangs.find(
        (element) => element === browserLang
      );
      browserLang = isLangAvailable != undefined ? browserLang : 'fr';
      if (browserLang) {
        this.changeLanguage(browserLang, false);
      }
    } else {
      this.setDefaultLang();
    }
  }

  changeLanguage(langKey: string, reload: boolean): any {
    const activeLanguage = localStorage.getItem('lang');
    if (activeLanguage != undefined && activeLanguage === langKey && reload) {
      return;
    }
    localStorage.setItem('lang', langKey);
    reload ? window.location.reload() : this.translate.use(langKey);
  }

  setDefaultLang(): void {
    this.translate.setDefaultLang('fr');
    localStorage.setItem('lang', 'fr');
  }
}
